import React from 'react'

const ProvinceDetails = ({selectedProvince,handleCloseModal}) => {
    const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount)
  }
  return (
    <div>
          <>
          <div className="modal fade show d-block " style={{zIndex:"9999"}} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title">
                    {selectedProvince?.name} - Complete Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Basic Information</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Province Code:</td>
                                <td>{selectedProvince?.code}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Province Name:</td>
                                <td>{selectedProvince?.name}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Regulatory Body:</td>
                                <td>{selectedProvince?.regulatory_body_name}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Acronym:</td>
                                <td>{selectedProvince?.regulatory_body_acronym}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Key Legislation:</td>
                                <td>{selectedProvince?.key_legislation}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Status:</td>
                                <td>
                                  <span className={`badge ${selectedProvince?.is_active ? 'bg-success' : 'bg-danger'}`}>
                                    {selectedProvince?.is_active ? 'Active' : 'Inactive'}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Rent Increase Rules</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Notice Period:</td>
                                <td>{selectedProvince?.rent_increase_notice_days} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Cap Percentage:</td>
                                <td>{selectedProvince?.rent_increase_cap_percentage}%</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Frequency:</td>
                                <td>{selectedProvince?.rent_increase_frequency_days} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Form Code:</td>
                                <td><span className="badge bg-secondary">{selectedProvince?.rent_increase_form_code}</span></td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Above Guideline:</td>
                                <td>
                                  {selectedProvince?.has_above_guideline_process ? (
                                    <span className="text-success">✓ Available</span>
                                  ) : (
                                    <span className="text-danger">✗ Not Available</span>
                                  )}
                                </td>
                              </tr>
                              {selectedProvince?.has_above_guideline_process && (
                                <tr>
                                  <td className="fw-bold">AGI Form Code:</td>
                                  <td><span className="badge bg-secondary">{selectedProvince?.above_guideline_form_code}</span></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Non-Payment & Eviction</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Non-Payment Notice:</td>
                                <td>{selectedProvince?.non_payment_notice_days} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Remedy Period:</td>
                                <td>{selectedProvince?.non_payment_remedy_days || 'N/A'} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Non-Payment Form:</td>
                                <td><span className="badge bg-secondary">{selectedProvince?.non_payment_form_code}</span></td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Eviction App Form:</td>
                                <td><span className="badge bg-secondary">{selectedProvince?.eviction_application_form_code}</span></td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Filing Fee:</td>
                                <td className="fw-bold text-primary">{formatCurrency(selectedProvince?.eviction_filing_fee)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Landlord Use & Tenant Terms</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Landlord Use Notice:</td>
                                <td>{selectedProvince?.landlord_use_notice_days} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Landlord Use Form:</td>
                                <td><span className="badge bg-secondary">{selectedProvince?.landlord_use_form_code}</span></td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Compensation:</td>
                                <td>{selectedProvince?.landlord_use_compensation_months} month(s) rent</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Tenant Termination:</td>
                                <td>{selectedProvince?.tenant_termination_notice_days} days</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Tenant Term Form:</td>
                                <td><span className="badge bg-secondary">{selectedProvince?.tenant_termination_form_code}</span></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Lease Requirements</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Standard Lease:</td>
                                <td>
                                  {selectedProvince?.has_standard_lease_form ? (
                                    <span className="text-success">✓ Available</span>
                                  ) : (
                                    <span className="text-danger">✗ Not Available</span>
                                  )}
                                </td>
                              </tr>
                              {selectedProvince?.has_standard_lease_form && (
                                <>
                                  <tr>
                                    <td className="fw-bold">Form Code:</td>
                                    <td><span className="badge bg-secondary">{selectedProvince?.standard_lease_form_code}</span></td>
                                  </tr>
                                  <tr>
                                    <td className="fw-bold">Mandatory:</td>
                                    <td>
                                      {selectedProvince?.lease_form_mandatory ? (
                                        <span className="text-danger">✓ Yes</span>
                                      ) : (
                                        <span className="text-warning">✗ No</span>
                                      )}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Service Methods</h6>
                        </div>
                        <div className="card-body">
                          <table className="table table-sm">
                            <tbody>
                              <tr>
                                <td className="fw-bold">Electronic Service:</td>
                                <td>
                                  {selectedProvince?.allows_electronic_service ? (
                                    <span className="text-success">✓ Allowed</span>
                                  ) : (
                                    <span className="text-danger">✗ Not Allowed</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Registered Mail:</td>
                                <td>
                                  {selectedProvince?.requires_registered_mail ? (
                                    <span className="text-danger">✓ Required</span>
                                  ) : (
                                    <span className="text-success">✗ Not Required</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="fw-bold">In-Person Service:</td>
                                <td>
                                  {selectedProvince?.allows_in_person_service ? (
                                    <span className="text-success">✓ Allowed</span>
                                  ) : (
                                    <span className="text-danger">✗ Not Allowed</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Proof of Service:</td>
                                <td>
                                  {selectedProvince?.requires_proof_of_service ? (
                                    <span className="text-danger">✓ Required</span>
                                  ) : (
                                    <span className="text-success">✗ Not Required</span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mb-4">
                      <div className="card">
                        <div className="card-header bg-light">
                          <h6 className="mb-0">Dispute Resolution</h6>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <table className="table table-sm mb-0">
                                <tbody>
                                  <tr>
                                    <td className="fw-bold">Filing Fee:</td>
                                    <td className="fw-bold text-primary">{formatCurrency(selectedProvince?.dispute_filing_fee)}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-bold">Online Portal:</td>
                                    <td>
                                      {selectedProvince?.has_online_dispute_portal ? (
                                        <span className="text-success">✓ Available</span>
                                      ) : (
                                        <span className="text-danger">✗ Not Available</span>
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div className="col-md-6">
                              {selectedProvince?.has_online_dispute_portal && (
                                <div>
                                  <p className="fw-bold mb-2">Portal URL:</p>
                                  <a
                                    href={selectedProvince?.dispute_portal_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-primary"
                                  >
                                    Visit Portal <i className="bi bi-box-arrow-up-right ms-1"></i>
                                  </a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={handleCloseModal}></div>
        </>
    </div>
  )
}

export default ProvinceDetails